export default __webpack_public_path__ + "static/couture_chat3-6d67bf80caf63aba0100354e7b7928fe.jpg";